export const BASE_URL = 'https://5e148887bce1d10014baea80.mockapi.io/keycash/challenge';
